//import worker from './workerServipay.js';
// import ServipayWorker from './servipay.worker.js';






/* 
const getAmountBuffer = (amount) => {
    var amountArray = [];
    for (var i = amount.length - 1; i >= 0; i--) {
        amountArray.push(amount[i]);
    }
    var buf = generateAmountBuffer(amountArray);
    var buffer = Buffer.from([0x06, 0x01, 0x0A, 0x04, buf[0], buf[1], buf[2], buf[3], buf[4], buf[5], 0x49, 0x09, 0x78]);
    return buffer;
}

const generateAmountBuffer = (bufferArray) => {
    console.log("generateAmountBuffer", bufferArray)
    var digitArr = [];
    var hexArr = [];
    // Format BufferArray
    // supprimer la virgule / la tourner correctement
    const index = bufferArray.indexOf('.');
    bufferArray.splice(index, 1);
    bufferArray = bufferArray.reverse();

    
    // ajoute zéro devant si la longueur est impaire
    // tableau activé
    if (bufferArray.length % 2 !== 0) {
        bufferArray.unshift('0');
    }

    // divisé en paires
    for (var i = bufferArray.length; i > 0; i -= 2) {
        digitArr.push(bufferArray.slice(i - 2, i));
    }

    // Un paiement comporte 6 chiffres, qui doivent être remplis de zéro s'il n'est pas occupé
    var zeroArray = ['0', '0']
    if (digitArr.length < 6) {
        for (var j = digitArr.length - 1; j < 6; j++) {
            digitArr.push(zeroArray);
        }
    }

    // formater correctement 0x00
    for (var k = digitArr.length - 2; k >= 0; k--) {
        hexArr.push("0x" + digitArr[k].join(""));
    }
    console.log("generateAmountBuffer result", hexArr)
    return hexArr;
}


const getMessage = (data) => {
    // Inscription
    console.log('getErrorMessage', this.bufferArray, this.bufferArray.toString('hex'), this.bufferArray.toString('hex').match(/../g))
    var result = this.bufferArray.toString('hex').match(/../g)
    if(result[0] === '80'){
        if(result[1] === '00'){
            return "(INSCRIPTION) Inscription réussie."
        }
    }

    // messages d'erreur
    if(result[0] === '84'){
        var errorMessage = result[1];
        console.log('errorMessage', errorMessage);
        var logString = "(Error:" + errorMessage + ") ";

        switch (errorMessage) {
            case undefined:
                return "";
            case '9a':
                return "ZVT protocol error. e. g. parsing errors, mandatory message element missing"
            default:
                return logString + " Erreur inconnue"
        }
    }
}

const readBuffer = (client, paid, amount) => {
   
} */


let myWorker;
let logsPayment = [];

export const getPaymentStatus = () => {
    return logsPayment;
}

export const pay = async ( ip, port, amount, comm) => {
/*     logsPayment = [];
    logsPayment.push({text:"Paiement", level:'controller', status: 'en cours', created_at:new Date(), data: `terminal ip : ${ip}, port: ${port}, montant de la transaction: ${amount} , communication: ${comm}`});        
    if (window.Worker) {
        try {
            logsPayment.push({text:"Initialisation du worker", status: '...', level:'worker', created_at:new Date()}); 
            if (!myWorker){
                myWorker = new ServipayWorker();
            }
            myWorker.onmessage = e => {
                console.log('ON MESSAGE NOT PARSED', e, e.data, typeof e.data)
                let result = typeof e.data !== Object ? JSON.parse(e.data) : e.data
                console.log('MESSAGE', e, e.data, result)
                logsPayment.push(result);  
                if (result.message === 'Init OK' || e.data.action === 'ready'){
                    myWorker.postMessage({message:'pay', ip, port, amount, comm}); 
                    logsPayment.push({text:"Demande de paiement", status: 'envoyée au worker', level:'controller', created_at:new Date()}); 
                }      
            }
            if (myWorker)
                myWorker.postMessage({message:'init'});
        }
        catch (e)
        {
            logsPayment.push({text:"Une erreur est survenue lors de init du worker : ", level:'controller', error: e.data, created_at:new Date()});   
            console.log('Une erreur est survenue lors de init du worker :', e)
            return false;
        }
    } else {
        logsPayment.push({text:"Initialisation du worker", status: 'echec', level:'worker', created_at:new Date(), error: "Le navigateur ne supporte pas les web workers, contactez l'équipe technique"}); 
        console.log('Your browser doesn\'t support web workers.');
    } */
};

export const stop =() => {

    console.log('Call to stop', myWorker)
    if (myWorker){
        myWorker.terminate();
        console.log('terminated ?', myWorker)
    
    } else {
        console.log('Not initialised');
    }
};
   /*  console.log('Call to pay');
    ip = '192.168.1.62'
    port = '5578';
    var paid = false;
    var client = new W3CWebSocket(`ws://${ip}:${port}/`, 'echo-protocol');
    client.onerror = function() {
        console.log('Connection Error');
    };
    
    client.onopen = function() {
        console.log('WebSocket Client Connected');
        client.send(Buffer.from([0x06, 0x00, 0x06, 0x12, 0x34, 0x56, 0x8A, 0x09, 0x78]));
    };
    
    client.onclose = function() {
        console.log('echo-protocol Client Closed');
    };
    
    client.onmessage = function(e) {
        if (typeof e.data === 'string') {
            console.log("Received: '" + e.data + "'");
        }
    }; */
    // client.addListener('data', function (data) {   
    //     var message =  getMessage(data);
    //     console.log('readBuffer', data, message);
    //     //emitter.emit('data', getMessage(data));
    //     if(message.includes("INSCRIPTION") && paid === false){
    //         client.write(getAmountBuffer(amount));
    //         paid = true;
    //         return true;
    //     } 
    // })

    // client.addListener('end',function(){
    //     console.log("Reading end");

    // });
    
    // client.addListener('error', function(err){
    //     console.log("Error: "+err.message);
    //     return false;
    // })
    //  console.log('A commencé à lire le Buffer');
    //  // Enregistrer
    // client.write(Buffer.from([0x06, 0x00, 0x06, 0x12, 0x34, 0x56, 0x8A, 0x09, 0x78]));
    // console.log("A envoyé une commande d'initialisation");
    // // pay
    
